




































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Player, MonitorPlayer } from "@/services/players/types";
import { playerMonitorPlayersFields } from "@/components/players/fields/playerMonitorPlayersFields";
import SelectPlayersModal from "@/components/players/modals/SelectPlayersModal.vue";
import PlayerMonitorPlayerRemoveModal from "@/components/players/modals/PlayerMonitorPlayerRemoveModal.vue";
@Component({
    components: { PlayerMonitorPlayerRemoveModal, SelectPlayersModal }
})
export default class PlayerMonitorPlayers extends Vue {
    @Prop() players!: Array<MonitorPlayer>;
    @Prop() collapseState!: boolean;
    // local state
    localPlayers = [] as Array<MonitorPlayer>;
    searchQuery = "";
    fields = playerMonitorPlayersFields;
    localCollapseState = true;
    sortBy = "name";
    sortDesc = false;

    mounted() {
        this.localCollapseState = this.collapseState;
    }

    @Watch("players", { immediate: true, deep: true })
    onPropertyChanged() {
        this.localPlayers = this.players;
    }

    // computed
    get filteredData() {
        return this.localPlayers && this.localPlayers
            .filter(x => this.searchQuery.length === 0 ||
                x.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
    }

    // methods
    openPlayersPrompt() {
        const alreadySelectedPlayerIds = this.localPlayers.map(x => x.id);
        (this.$refs.selectPlayers as any).open(alreadySelectedPlayerIds, true);
    }

    setState(state:boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "PlayerMonitorPlayers.vue", state: state });
    }

    onPlayerSelected(data: Player[]) {
        const playersToBeAdded = data
            .filter(x => !this.localPlayers.map(x => x.id).includes(x.id));
        if (playersToBeAdded.length > 0) {
            this.localPlayers = this.localPlayers.concat(playersToBeAdded.map(player => {
                return {
                    id: player.id,
                    name: player.name,
                    playerId: player.playerId
                } as MonitorPlayer;
            }));
        }
    }

    removePlayer(player: MonitorPlayer) {
        (this.$refs.removePlayer as any).open(player.id, player.name);
    }

    onRemoved(id: string) {
        const item = this.localPlayers.find(x => x.id === id);
        if (!item) {
            return;
        }
        this.localPlayers = this.localPlayers.filter(x => x.id !== id);
    }

    // events
    emitData() {
        this.$emit("playersUpdated", this.localPlayers);
    }
}
